<!-- Note that we must read the _computed_ signal for changes to happen -->
@if (theme()) {
  <button mat-icon-button
          (click)="toggle('light')"
          aria-label="Växla till ljust läge">
    <mat-icon>light_mode</mat-icon>
  </button>
} @else {
  <button mat-icon-button
          (click)="toggle('dark')"
          aria-label="Växla till mörkt läge">
    <mat-icon>dark_mode</mat-icon>
  </button>
}
